import dynamic from 'next/dynamic'
import { string } from 'prop-types'
import Layout from '../../layouts/layout'
import CategoryPageComponentShimmer from '../category/category-shimmer'
import ProductPageComponentShimmer from '../product/product-shimmer'
import CmsPageComponentShimmer from '../cms-page/cms-page-shimmer'
import ContactsComponentShimmer from '../contacts/contacts-shimmer'
import WorkWithUsComponentShimmer from '../work-with-us/work-with-us-shimmer'
import StoreLocatorComponentShimmer from '../store-locator/store-locator-shimmer'
import StoreLocatorDetailComponentShimmer from '../store-locator/store-locator-detail-shimmer'
import BlogComponentShimmer from '../blog/blog-shimmer'
import MasterDataComponentShimmer from '../master-data/master-data-shimmer'
import WorkWithUsAdvancedComponentShimmer from '../work-with-us-advanced/work-with-us-advanced-shimmer'
import MacroCategoryPageComponentShimmer from '../macro-category/macro-category-shimmer'
import { useUserData } from '@bluheadless/ui-logic/src/providers/user'
import { useSalesAgentData } from '@bluheadless/ui-logic/src/providers/sales-agent'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'

const BlogPageComponent = dynamic(() => import('../blog'), { loading: BlogComponentShimmer })
const CategoryPageComponent = dynamic(() => import('../category'), {
	loading: CategoryPageComponentShimmer,
})
const MacroCategoryPageComponent = dynamic(() => import('../macro-category'), {
	loading: MacroCategoryPageComponentShimmer,
})
const CmsPagePageComponent = dynamic(() => import('../cms-page'), {
	loading: CmsPageComponentShimmer,
})
const ContactsPageComponent = dynamic(() => import('../contacts'), {
	loading: ContactsComponentShimmer,
})
const MasterDataPageComponent = dynamic(() => import('../master-data'), {
	loading: MasterDataComponentShimmer,
})
const ProductPageComponent = dynamic(() => import('../product'), {
	loading: ProductPageComponentShimmer,
})
const QuizPageComponent = dynamic(() => import('../quiz'))
const StoreLocatorPageComponent = dynamic(() => import('../store-locator'), {
	loading: StoreLocatorComponentShimmer,
})
const StoreLocatorDetailPageComponent = dynamic(() => import('../store-locator/store-locator-detail'), {
	loading: StoreLocatorDetailComponentShimmer,
})
const WorkWithUsPageComponent = dynamic(() => import('../work-with-us'), { loading: WorkWithUsComponentShimmer })
const WorkWithUsAdvancedPageComponent = dynamic(() => import('../work-with-us-advanced'), {
	loading: WorkWithUsAdvancedComponentShimmer,
})

const UrlResolverPageComponent = ({ entityType, entityId, ...props }) => {
	const renderEntity = () => {
		switch (entityType) {
			case 'cms-page':
				return (
					<CmsPagePageComponent
						key={`cms-page-url-resolver-${entityType}-${entityId}`}
						entityId={entityId}
						{...props}
					/>
				)
			case 'master_data':
				return (
					<MasterDataPageComponent
						key={`master-data-url-resolver-${entityType}-${entityId}`}
						entityId={entityId}
						{...props}
					/>
				)
			case 'product':
				return (
					<ProductPageComponent key={`product-url-resolver-${entityType}-${entityId}`} entityId={entityId} {...props} />
				)
			case 'category':
				return (
					<CategoryPageComponent
						key={`category-url-resolver-${entityType}-${entityId}`}
						entityId={entityId}
						{...props}
					/>
				)
			case 'macro-category':
				return (
					<MacroCategoryPageComponent
						key={`macro-category-url-resolver-${entityType}-${entityId}`}
						entityId={entityId}
						{...props}
					/>
				)
			case 'store-locator':
				return <StoreLocatorPageComponent key={`store-locator-url-resolver`} {...props} />
			case 'store-locator-detail':
				return (
					<StoreLocatorDetailPageComponent
						key={`store-locator-detail-url-resolver-${entityType}-${entityId}`}
						entityId={entityId}
						{...props}
					/>
				)
			case 'contacts':
				return <ContactsPageComponent key={`contacts-url-resolver`} {...props} />
			case 'workwithus':
				return <WorkWithUsPageComponent key={`work-with-us-url-resolver`} {...props} />
			case 'quiz':
				return <QuizPageComponent key={`quiz-url-resolver`} {...props} />
			case 'blog':
				return <BlogPageComponent key={`blog-url-resolver`} {...props} />
			case 'workwithus-advanced':
				return <WorkWithUsAdvancedPageComponent key={`work-with-us-advanced-url-resolver`} {...props} />
			case 'global-catalog':
				return <CategoryPageComponent key={`global-catalog-url-resolver`} {...props} />
			default:
				return null
		}
	}
	const {
		restriction: { enabled: restrictionEnabled },
	} = useConfig()
	const { isLoggedIn: isCustomerLoggedIn } = useUserData()
	const { isLoggedIn: isSalesAgentLoggedIn } = useSalesAgentData()

	return (
		<Layout
			restrictionEnabled={restrictionEnabled && !isCustomerLoggedIn && !isSalesAgentLoggedIn}
			entityLayout={props?.layout?.template}
			layoutProps={props.layout}
		>
			{renderEntity()}
		</Layout>
	)
}

UrlResolverPageComponent.defaultProps = {}

UrlResolverPageComponent.propTypes = {
	entityType: string.isRequired,
}

export default UrlResolverPageComponent
